window.apigateway = {
    enums: window.trialcard_enums,
    shared: window.trialcard_shared,
    authentication: window.trialcard_authentication,
    models: window.trialcard_apigateway_models,
    client: window.trialcard_apigateway,
};
